import { LogoDark } from "@/constant/imagePath";
import { isMobileViewHook } from "@/customHooks/isMobileViewHook";
import { cn } from "@/helper/HelperFunction";
import { useEffect, useState } from "react";
import styles from "./Logo.module.css";

export default function Logo({
  variant = "logo",
  type,
  isCollapsed,
  disableMobileChange = false,
  customClass,
  theme = "light",
}) {
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (!disableMobileChange) {
      isMobileViewHook(setMobile, 480);
    }
  }, [disableMobileChange]);

  const logoSrcVariant = (theme = "light") => {
    return {
      icon: theme === "light" ? LogoDark : LogoDark,
      logo:
        (mobile && !disableMobileChange) || isCollapsed
          ? theme === "light"
            ? LogoDark
            : LogoDark
          : theme === "light"
          ? LogoDark
          : LogoDark,
    };
  };

  return (
    <div
      className={cn(
        styles.logo,
        type === "header" && styles.headerLogo,
        type === "dashboardHeader" && styles.dashboardHeaderLogo,
        customClass
      )}
    >
      <img src={logoSrcVariant(theme)[variant]} alt="Logo" />
    </div>
  );
}
